


















import Vue from 'vue'
import Component from 'vue-class-component';
import {State} from 'vuex-class';
import {Tag} from '@/modules/blog/types';
import {Prop} from 'vue-property-decorator';
import {notify} from '@/modules/core/notification';

/**
 * Diálogo para la confirmación de etiquetas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ConfirmDeleteTag extends Vue {
    /**
     * Etiqueta actualmente en edición
     *
     * @var { Tag }
     */
    @State(state => state.blog.tag)
    public tag: Tag

    /**
     * Controla la visibilidad del dialogo
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    public removing = false

    /**
     * Elimina una etiqueta de la aplicación
     */
    public async remove () {
        this.removing = true
        const name = this.tag.name
        await this.$store.dispatch('blog/deleteTag')


        this.$emit('input', false)
        this.removing = false
        notify(`La etiqueta ${name} ha sido eliminada correctamente`)
    }
}
